import type {
  AtualizacaoDeItemDeDownload,
  ItemDeDownload,
  NovoItemDeDownload,
  StatusDoDownload,
} from './types'

type Ouvinte = () => void

const STATUS_PENDENTES: StatusDoDownload[] = [
  'na-fila',
  'baixando',
  'comprimindo',
]

let itens: ItemDeDownload[] = []
let proximoId = 0

const ouvintes = new Set<Ouvinte>()

function notificar(): void {
  for (const ouvinte of ouvintes) {
    ouvinte()
  }
}

export function estaPendente(item: ItemDeDownload): boolean {
  return STATUS_PENDENTES.includes(item.status)
}

export function inscrever(ouvinte: Ouvinte): () => void {
  ouvintes.add(ouvinte)

  return () => {
    ouvintes.delete(ouvinte)
  }
}

export function obterItens(): ItemDeDownload[] {
  return itens
}

export function atualizarItem(
  id: string,
  atualizacao: AtualizacaoDeItemDeDownload
): void {
  let alterou = false

  itens = itens.map(item => {
    if (item.id !== id) return item

    alterou = true
    return { ...item, ...atualizacao }
  })

  if (alterou) notificar()
}

export function adicionarItem(novoItem: NovoItemDeDownload): string {
  if (novoItem.id && itens.some(item => item.id === novoItem.id)) {
    const { id, ...atualizacao } = novoItem
    atualizarItem(id, atualizacao)
    return id
  }

  proximoId += 1

  const item: ItemDeDownload = {
    status: 'na-fila',
    ...novoItem,
    id: novoItem.id ?? `download-${proximoId}`,
  }

  itens = [...itens, item]
  notificar()

  return item.id
}

export function removerItem(id: string): void {
  const restantes = itens.filter(item => item.id !== id)

  if (restantes.length === itens.length) return

  itens = restantes
  notificar()
}

export function limparItens(): void {
  if (itens.length === 0) return

  itens = []
  notificar()
}
